var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-header',{staticClass:"pb-10"},[_c('b-card-title',[_vm._v("Academic in each State")])],1),_c('VueApexCharts',{attrs:{"height":"550","type":"bar","options":_vm.options,"series":_vm.series[_vm.citizenShip]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }